import type { DateValue } from 'components/filter/input/DateRangePicker/types';

export const timeZoneSafeDateString = (date?: Date): string | undefined =>
  date
    ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().split('T')[0]
    : undefined;

const dateKey = (date: Date | undefined): string => timeZoneSafeDateString(date) ?? 'none';

export const getRangeKey = (value: DateValue): string => {
  const presetValue = value.range?.presetValue ?? 'custom';
  const from = dateKey(value.range?.from);
  const to = dateKey(value.range?.to);
  return `${presetValue}|${from}|${to}`;
};

export const getComparisonKey = (value: DateValue): string => {
  const presetValue = value.comparison?.presetValue ?? 'no_comparison';
  const from = dateKey(value.comparison?.from);
  const to = dateKey(value.comparison?.to);
  return `${presetValue}|${from}|${to}`;
};
